export interface LogEntry {
  ts: number;
  level: 'debug' | 'info' | 'warn' | 'error';
  module: string;
  message: string;
}

const BUFFER_SIZE = 4000;
const buffer = new Array<LogEntry>(BUFFER_SIZE);
let head = 0;
let count = 0;

export function pushLogEntry(entry: LogEntry): void {
  buffer[head] = entry;
  head = (head + 1) % BUFFER_SIZE;
  if (count < BUFFER_SIZE) count++;
}

export function getLogEntries(): LogEntry[] {
  if (count === 0) return [];
  if (count < BUFFER_SIZE) return buffer.slice(0, count);
  // Ring is full — return in chronological order
  return [...buffer.slice(head), ...buffer.slice(0, head)];
}

export function clearLogBuffer(): void {
  head = 0;
  count = 0;
}

/**
 * Downloads all buffered log entries as a .txt file.
 * Call from the browser console in production: window.__dumpLogs()
 */
export function dumpLogs(): void {
  const entries = getLogEntries();
  if (entries.length === 0) {
    console.info('[logBuffer] No log entries in buffer.');
    return;
  }

  const lines = entries.map(
    (e) => `${new Date(e.ts).toISOString()} [${e.level.toUpperCase().padEnd(5)}] [${e.module}] ${e.message}`
  );

  const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `roc-logs-${new Date().toISOString().replace(/[:.]/g, '-')}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  console.info(`[logBuffer] Dumped ${entries.length} entries.`);
}
